import { AuditRecord } from '../types';

interface AuditTableProps {
  records: AuditRecord[];
}

/** Audit log table with columns per FR-007 contract. */
export default function AuditTable({ records }: AuditTableProps) {
  if (records.length === 0) {
    return <p style={{ color: 'var(--color-text-muted)', fontSize: '14px' }}>No audit records found. Try adjusting the date range.</p>;
  }

  return (
    <table className="audit-table">
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>User</th>
          <th>Question</th>
          <th>Answer</th>
          <th>Sources</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record, i) => (
          <tr key={`${record.sessionId}-${record.timestamp}-${i}`}>
            <td style={{ whiteSpace: 'nowrap' }}>
              {new Date(record.timestamp).toLocaleString('en-AU')}
            </td>
            <td>{record.userEmail}</td>
            <td>{record.queryText}</td>
            <td>
              {record.responseText.substring(0, 150)}{record.responseText.length > 150 ? '...' : ''}
            </td>
            <td style={{ fontFamily: 'var(--font-mono)', fontSize: '11px' }}>
              {record.citedSources.map(s => s.filePath).join(', ')}
            </td>
            <td>
              <span style={{
                padding: '2px 8px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: 500,
                background: record.groundingStatus === 'grounded' ? '#e6f4ea' : record.groundingStatus === 'partial' ? '#fef7e0' : '#fce8e6',
                color: record.groundingStatus === 'grounded' ? '#137333' : record.groundingStatus === 'partial' ? '#b05a00' : '#c5221f',
              }}>
                {record.groundingStatus}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
